import { useModernComponent } from '~/hooks';
import { Colors } from '~/themes/colors';
import { BackButton } from './BackButton';
import BackButtonLegacy from './Legacy';
import { IBackButtonProps } from './Types';

export const BackButtonProxy = ({
  onClick,
  url,
  color = Colors.secondary_500,
}: IBackButtonProps) => {
  const isUseModern = useModernComponent('commons.BackButton');

  if (!isUseModern) {
    return <BackButtonLegacy onClick={onClick} url={url} color={color} />;
  }

  return <BackButton onClick={onClick} url={url} color={color} />;
};
